import styled from '@emotion/styled';

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 8px;
`;

export const Dot = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
  background-color: ${({ theme }) => theme.colors.zinc_200};
  margin: 5px;
`;

export const InfoSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
`;

export const Bar = styled.div<{ width: number }>`
  height: 14px;
  width: ${({ width }) => width}px;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.zinc_200};
`;
